import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemConstants } from "../TandemConstants";
import { TandemEventDefinition } from "../TandemTypes";

type SourceTypeMapping = (typeof TandemConstants)["SOURCE_TYPE"];
type SourceType = SourceTypeMapping[keyof SourceTypeMapping]["name"] | "Unknown";

export type CarbEnteredPayload = {
  carbs: number;
  source_type?: number;
};

export type CarbEnteredEvent = {};

const carbEnteredSchema = z.object({
  carbs: z.number(),
  source_type: cz.permissive(z.number()),
});

const getSourceType = (sourceType?: number): SourceType => {
  const sourceMapping = TandemConstants.SOURCE_TYPE;
  for (const i in sourceMapping) {
    const item = sourceMapping[i as keyof SourceTypeMapping];
    if (sourceType === item.value) {
      return item.name;
    }
  }
  return "Unknown";
};

export const LID_CARB_ENTERED = {
  value: 0x30,
  name: "Carbs Entered Event",
  format: "fb...........",
  fields: ["carbs", "source_type"],
  postprocess: rec => ({
    carbs: rec.carbs,
    sourceType: getSourceType(rec.source_type),
  }),
  schema: carbEnteredSchema,
} as const satisfies TandemEventDefinition<CarbEnteredPayload, CarbEnteredEvent>;
